import styled from "styled-components";

import { color } from "../../theme/color";

type SliderProps = {
    label: string;
    value: number;
    min: number;
    max: number;
    step: number;
    /** How the value reads next to the label, like "20 px". */
    format(value: number): string;
    onChange(value: number): void;
};

/** A setting to slide between a smallest and a largest value, with the value next to its name. */
export function Slider({ label, value, min, max, step, format, onChange }: SliderProps) {
    return (
        <Field>
            <Top>
                {label}
                <Value>{format(value)}</Value>
            </Top>
            <Range type="range" min={min} max={max} step={step} value={value} onChange={(event) => onChange(Number(event.target.value))} />
        </Field>
    );
}

const Field = styled.label`
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 14px;
    color: ${color.textSoft};
`;

const Top = styled.span`
    display: flex;
    justify-content: space-between;
`;

const Value = styled.span`
    font-weight: 600;
    color: ${color.text};
`;

const Range = styled.input`
    width: 100%;
    height: 32px;
    margin: 0;
    accent-color: ${color.accent};
    cursor: pointer;
`;
